import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resume-reports',
  templateUrl: './resume-reports.component.html',
  styleUrls: ['./resume-reports.component.scss']
})
export class ResumeReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
